import { debounce } from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useRef, useState } from 'react';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { colors } from '../../../../../colorVars';
import { getNotificationSymbol } from '../../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationSymbol';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { useAlertsStore } from '../../../../../stores/websocketStore/_alertsStore';
import CloseWindowButton from '../../../../atomic/buttons/closeWindow/CloseWindowButton';
import { Body2, fontSizes } from '../../../../atomic/text/Text';
import { groupNumberMap } from '../alertWatchlistComponent/groupNumberMap';
import { useKeyPress } from '../alertWatchlistComponent/utils/useKeyPress';
import style from './AlertNotificationComponent.module.css';
import { NotificationRow } from './notificationListItem/NotificationRow';
import { NotificationTableHeader } from './notificationTableHeader/NotificationTableHeader';

export const AlertNotificationComponent = observer(
  ({ details, moduleId, layoutType }) => {
    const { layoutStore } = useWebsocketStore();
    const alertStore = useAlertsStore();
    const parentNodeRef = useRef();
    const notificationsStore = alertStore.notificationStore;
    const groupNumber = details?.groupNumber || 0;
    

    const [selectedNotification, setSelectedNotification] = useState(null);

    const updateSelectedGroupData = (notification, currentGroupNumber) => {
      const symbol = getNotificationSymbol(notification) ?? null;
      if (symbol) {
        layoutStore.setSelectedGroupData(currentGroupNumber, { symbol });
      }
    };
    const debouncedFunction = useMemo(
      () => debounce(updateSelectedGroupData, 100),
      [groupNumber]
    );
    useEffect(() => {
      if (selectedNotification) {
        debouncedFunction(selectedNotification, groupNumber);
      }
    }, [selectedNotification]);

    useEffect(() => {
      if (layoutStore.currentFocusedModule !== moduleId)
        setSelectedNotification(null);
    }, [layoutStore.currentFocusedModule]);

    const handleArrowKeyPress = (event) => {
      event.preventDefault();
      if (
        selectedNotification &&
        layoutStore.currentFocusedModule === moduleId
      ) {
        const index = sortedArray.findIndex(
          (item) => item.notificationId === selectedNotification.notificationId
        );
        if (event.key === 'ArrowUp') {
          if (index !== 0) {
            const newIndex = index - 1;
            setSelectedNotification(sortedArray[newIndex]);
          }
        } else {
          const arrayLength = sortedArray.length;
          if (index !== arrayLength - 1) {
            const newIndex = index + 1;
            setSelectedNotification(sortedArray[newIndex]);
          }
        }
      }
    };
    useKeyPress(
      ['ArrowUp', 'ArrowDown'],
      handleArrowKeyPress,
      parentNodeRef.current
    );

    const watchlistsInGroup =
      layoutStore.alertWatchlistNamesByGroupNumber[groupNumber];

    const notificationsArray = watchlistsInGroup.reduce(
      (acc, watchlistName) => {
        if (!notificationsStore.notificationsByWatchlist[watchlistName])
          return acc;
        return [
          ...acc,
          ...Object.values(
            notificationsStore.notificationsByWatchlist[watchlistName]
          ),
        ];
      },
      []
    );

    const sortedArray = notificationsArray.sort(
      (a, b) => b.timestamp - a.timestamp
    );
    const removeModule = () => {
      layoutStore.removeModuleFromCurrentLayout(layoutType, moduleId);
    };

    return (
      <div
        ref={parentNodeRef}
        className={style.container}
        onClick={() => layoutStore.setCurrentFocusedModule(moduleId)}
      >
        <header className={style.header}>
          <div className={style.group}>
            <Body2 margin="0 5px 0 0" color={colors.lightGrey} fontWeight={700}>
              Notifications
            </Body2>
            <select
              value={groupNumber}
              onChange={({ target }) => {
                layoutStore.updateCurrentLayoutModuleGroupNumber(
                  'alerts',
                  moduleId,
                  target.value
                );
                layoutStore.updateServerCurrentLayout(
                  'alerts',
                  'currentAlerts'
                );
              }}
              className={style.groupSelect}
              style={{
                backgroundColor: groupNumberMap[groupNumber].color,
                color: groupNumber === '6' ? colors.black : colors.lightGrey,
                border: 'none',
                fontSize: fontSizes.body4,
                fontWeight: 700,
              }}
            >
              {groupNumberMap.map(({ value, label, color }) => (
                <option
                  key={value}
                  value={value}
                  style={{ backgroundColor: color }}
                >
                  {label}
                </option>
              ))}
            </select>
          </div>

          <CloseWindowButton
            width={15}
            stroke={2}
            color={colors.red}
            handleClick={removeModule}
          />
        </header>
        <div className={style.body}>
          <table className={style.table}>
            <NotificationTableHeader />
            <tbody>
              {sortedArray.map((notification) => (
                <NotificationRow
                  key={notification.notificationId}
                  notification={notification}
                  setSelectedNotification={setSelectedNotification}
                  selectedNotification={selectedNotification}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
);
